import React from "react";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import ModalAutorizacionAlimento from "../components/ModalInformacion/ModalInfoAutoACuarentena.jsx";

class AutorizacionAlimentosCuarentena extends React.Component {
  initialState = {
    buscar: {},
    caso_especial: {
        id: "",
        solicitud_id: "",
        tipo_importacion_id: "",
        usuario_id: "",
        folio_establecimiento: "",
        status: "",
        created: "",
        modified: "",
        casos_especiales_establecimiento_id: "",
        documentacion: [],
        datos_importacion: {},
        establecimiento: {},
        tipo_importacion: {},
        productos: [],
        todosDocsAprobados: false,
      },
      solicitud_ce: {
        id: "",
        folio_solicitud: "",
        accion_id: "",
        tramite_id: "",
        estatus_tramite_id: "",
        fecha_solicitud: "",
        estatus: {},
        tramite: {},
        accion: {},
      },
    modalImportDataState: false,
    importador_razon_social: "",
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  mi_grid = {};
  componentDidMount() {
    let grid = {
      source: "app/getAutorizacionAlimentosCuarentena", 
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        importador_razon_social: {
          label: "Importador",
          render: (me) => {
            me.innerHTML = me.data.importador_razon_social.toUpperCase();
          },
        },
        no_factura: {
          label: "Número de factura",
        },
      },
      buttons: [
        {
          iconClass: "fa fa-eye",
          btnClass: "btn bg-gradient-blue",
          title:"Ver datos de importación",
          btnClick: (datos) => {
            this.openModalImportView(datos);
          },
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      render: (form) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "importador",
            label: "Importador",
            placeHolder: "importador",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "no_factura",
            label: "Número de factura",
            placeHolder: "Número de factura",
            cols: 5,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar: busqueda.data() });
              let search = this.state.buscar;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  openModalImportView = (datos) => {
    Api.loading(true);

    let detalleCasoEspecialId = datos.detalle_casos_especiales_id,
      importador_razon_social = datos.importador_razon_social;

    Api.fetch(
      "app/getInfoCasoEspecial?detalle_caso_especial_id=" +
        detalleCasoEspecialId
    ).then((ce) => {
      this.setState({
        caso_especial: ce.caso_especial,
        solicitud_ce: ce.solicitud,
        modalImportDataState: true,
        importador_razon_social: importador_razon_social,
      });

      Api.loading(false);
    });
  };

  handleModalImportDataCloseBtn = (e) => {
    this.setState({
      modalImportDataState: this.initialState.modalImportDataState,
      caso_especial: this.initialState.caso_especial,
      solicitud_ce: this.initialState.solicitud_ce,
      importador_razon_social: this.initialState.importador_razon_social,
    });
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">Autorización de alimentos</li>
        </ol>
        <h1 className="page-header">Autorización de alimentos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>

        {/**Modal para ver la información*/}
        <Modal
              isOpen={this.state.modalImportDataState}
              tabIndex="-1"
              style={{
                maxWidth: "100%",
                width: "85%",
              }}
            >
              <ModalHeader
                width="100%"
                toggle={this.handleModalImportDataCloseBtn}
                className="text-center"
              >
                Importador: {this.state.importador_razon_social}
              </ModalHeader>
              <ModalBody>
                <ModalAutorizacionAlimento
                  state={this.state}
                  handleModalImportDataCloseBtn={
                    this.handleModalImportDataCloseBtn
                  }
                ></ModalAutorizacionAlimento>
              </ModalBody>
            </Modal>
        
      </div>
    );
  }
}

export default AutorizacionAlimentosCuarentena;